import { List } from '@mui/material';
import NavItem from 'src/layouts/DashboardLayout/NavBar/NavItem';
import { matchPath } from 'react-router-dom';

export function renderNavItems({ items, pathname, expanded, depth = 0, statuses }) {
  return (
    <List disablePadding>
      {items.reduce((acc, item) => reduceChildRoutes({ acc, item, pathname, depth, expanded, statuses }), [])}
    </List>
  );
}

export function reduceChildRoutes({ acc, pathname, item, depth, expanded, statuses }) {
  const key = item.title + depth;
  const route = item.route;
  const isContentRoute = route?.splitTarget === 'content';
  const status = item.status || (item.statusKey ? statuses?.[item.statusKey] : undefined);

  if (item.items) {
    let open = null;

    if (route?.path && !isContentRoute) {
      open = matchPath(
        {
          path: route.path,
          end: false,
        },
        pathname,
      );
    }

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        open={Boolean(open)}
        title={item.title}
        expanded={expanded}
        route={route}
        status={status}
        disabledState={item.disabledState}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items,
          statuses,
        })}
      </NavItem>,
    );
  } else if (route?.accessible) {
    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        title={item.title}
        expanded={expanded}
        route={route}
        status={status}
        disabledState={item.disabledState}
      />,
    );
  }

  return acc;
}
